export default __webpack_public_path__ + "static/media/logo.270baaae.png";